export enum YesNoButtonsMode {
    FLEX = 'flex-buttons',
    DEFAULT = 'default-buttons'
}
